import { render, staticRenderFns } from "./PostMortemReport.vue?vue&type=template&id=d39df588"
import script from "./PostMortemReport.vue?vue&type=script&lang=js"
export * from "./PostMortemReport.vue?vue&type=script&lang=js"
import style0 from "./PostMortemReport.vue?vue&type=style&index=0&id=d39df588&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports